// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveLearningProjection_wrapper__2GRPm"};